import React, { FC } from 'react';

import { useTranslation } from 'app/lang';

import { MATCH_HEADER, OUTRIGHT_HEADER } from '../../../../constants';

import styles from './RightCellDefault.module.scss';

// ---

type RightCellDefaultProps = {
  expanded: boolean;
  isHeadToHead?: boolean;
};

const RightCellDefault: FC<RightCellDefaultProps> = ({ expanded, isHeadToHead }) => {
  const { t } = useTranslation();

  const header = isHeadToHead ? MATCH_HEADER : OUTRIGHT_HEADER;
  const subtitle = expanded ? header.subtitleExpanded : header.subtitleCollapsed;

  return (
    <div className={styles.root}>
      <span className={styles.title}>{t(header.title)}</span>
      {t(subtitle)}
    </div>
  );
};

export default RightCellDefault;
